import axios from 'axios';
import { clearStoragePreservingTheme } from './theme';

const API = axios.create({ baseURL: '/api' });

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

API.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) {
    clearStoragePreservingTheme();
    window.location.href = '/';
  }
  return Promise.reject(err);
});

export default API;
